module.exports = __webpack_public_path__ + "img/WTA_PlayerZone_Desktop.864d33cd.jpg";